/**
 * @owner @Appboy/agent-console
 */

import { appendFormDataValue } from "../formData";
import type { PostwsGenerativeAiAppGroupIdStandardsRulesetSynthesisProps } from "./types";

/**
 * Builds the multipart body AsyncStandardsRulesetSynthesisController reads. Always multipart: files
 * are the whole input here, unlike the brand guidelines synthesis endpoint's optional-uploads JSON
 * branch. The other fields ride as ordinary form fields (the controller coerces them back).
 * existing_rulesets flattens to existing_rulesets[][name] / [][scope] parts; an empty list sends
 * no parts, which the controller reads as none. Without a model choice no provider, model or
 * thinking_level part is sent, which the controller reads as Braze Auto.
 */
export const buildStandardsRulesetSynthesisFormData = ({
  interactionSite,
  existingRulesets,
  files,
  modelChoice,
  jobToken,
}: Pick<
  PostwsGenerativeAiAppGroupIdStandardsRulesetSynthesisProps,
  "interactionSite" | "existingRulesets" | "files" | "modelChoice" | "jobToken"
>): FormData => {
  const body = new FormData();
  appendFormDataValue(body, "job_token", jobToken);
  appendFormDataValue(body, "interaction_site", interactionSite);
  appendFormDataValue(
    body,
    "existing_rulesets",
    existingRulesets.map(({ name, scope }) => ({ name, scope }))
  );
  // Each file becomes a files[] part the backend validates and encodes into a document part.
  appendFormDataValue(body, "files", files);
  appendFormDataValue(body, "provider", modelChoice?.provider);
  appendFormDataValue(body, "model", modelChoice?.model);
  appendFormDataValue(body, "thinking_level", modelChoice?.thinkingLevel);
  return body;
};
